//http://wx.hztywl.cn/bzb/h5.html?#/nurse/alarm
// http://localhost:8080/h5.html?#/nurse/alarm

// http://localhost:8080/h5.html?#/nurse/alarm?callId=148165087232
// http://wx.hztywl.cn/bzb/h5.html?#/nurse/alarm?callId=148165087232


export default [
  //网约护士医生端一键报警
  {
    path: '/nurse/alarm',
    meta: {
      title: '一键报警'
    },
    component: () => import('../pages/nurse/alarm')
  },
]



// WEBPACK FOOTER //
// ./h5/router/nurse.js